module.exports = __webpack_public_path__ + "img/biritibamirim.bca17e2a.png";